import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Nav, NavDropdown, NavItem, MenuItem } from 'react-bootstrap';

import NavbarLink from '../navbar-link';

import { getFullUserDisplayName } from '../../../tools';

const userAccountRootRoute = '/user-account';

class NavbarCurrentUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    };

    this.toggleNavDropdown = this.toggleNavDropdown.bind(this);
  }

  toggleNavDropdown() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    const { user, onSignOut } = this.props;
    const { isOpen } = this.state;

    const title = getFullUserDisplayName(user);

    return (
      <Nav pullRight>
        <NavDropdown
          title={title}
          id="basic-nav-dropdown"
          open={isOpen}
          onToggle={this.toggleNavDropdown}
        >
          <NavbarLink
            to={`${userAccountRootRoute}/profile`}
            onClick={this.toggleNavDropdown}
          >
            Profile
          </NavbarLink>
          <NavbarLink
            to={`${userAccountRootRoute}/change-email`}
            onClick={this.toggleNavDropdown}
          >
            Change Email
          </NavbarLink>
          <NavbarLink
            to={`${userAccountRootRoute}/change-password`}
            onClick={this.toggleNavDropdown}
          >
            Change Password
          </NavbarLink>
          <NavbarLink
            to={`${userAccountRootRoute}/settings`}
            onClick={this.toggleNavDropdown}
          >
            Account Settings
          </NavbarLink>
          <MenuItem divider />
          <NavItem onSelect={onSignOut}>Sign Out</NavItem>
        </NavDropdown>
      </Nav>
    );
  }
}

NavbarCurrentUser.propTypes = {
  user: PropTypes.object.isRequired,
  onSignOut: PropTypes.func.isRequired
};

export default NavbarCurrentUser;



// WEBPACK FOOTER //
// ./src/components/common/navbar/navbar-current-user.js